import { atom } from "jotai";
import type { WeatherStation } from "@/types";

const activeStationAtom = atom<WeatherStation | null>(null);

export { activeStationAtom };
